import React, { useState, useRef } from 'react';
import './homeCarousel.css'; // Updated CSS file
const offers = [
    {
      id: 1,
      image: 'https://www.shutterstock.com/image-photo/modern-hotel-bulding-600nw-2465439621.jpg',
      category: 'DOM FLIGHTS',
      title: 'Grab FLAT 12% OFF* on Domestic Flights',
      description: 'with American Express Cards.',
      expiry: 'Expires 28 Mar 25',
      buttonText: 'VIEW DETAILS',
    },
    {
      id: 2,
      image: 'https://www.shutterstock.com/image-photo/modern-hotel-bulding-600nw-2465439621.jpg',
      category: 'CABS',
      title: 'Maha Shivratri-special Deals:',
      description: 'Up to 15% OFF*',
      buttonText: 'BOOK NOW',
    },
    {
      id: 3,
      image: 'https://www.shutterstock.com/image-photo/modern-hotel-bulding-600nw-2465439621.jpg',
      category: 'INTL HOTELS',
      title: 'FOR THIS CRICKET SEASON IN DUBAI:',
      description: 'Grab Up to 25% OFF on hotels & homestays',
      buttonText: 'BOOK NOW',
    },
    {
      id: 4,
      image: 'https://www.shutterstock.com/image-photo/modern-hotel-bulding-600nw-2465439621.jpg',
      category: 'DOM HOTELS',
      title: 'Hotels in Spotlight:',
      description: 'Luxury Stays Chosen by Our Experts for Your Next Relaxing Break.',
      buttonText: 'EXPLORE NOW',
    },
    // New Categories (5-14)
    {
      id: 5,
      image: 'https://www.shutterstock.com/image-photo/luxury-resort-spa-hotel-pool-600nw-2285994453.jpg',
      category: 'RESORTS',
      title: 'Summer Escape Deals:',
      description: 'Up to 30% OFF on Luxury Resorts Worldwide',
      expiry: 'Expires 15 Apr 25',
      buttonText: 'BOOK NOW',
    },
    {
      id: 6,
      image: 'https://www.shutterstock.com/image-photo/elegant-restaurant-interior-luxury-dining-600nw-2285994453.jpg',
      category: 'DINING',
      title: 'Dine Out Special:',
      description: 'Enjoy 20% OFF at Top Restaurants with Our Partner Cards',
      expiry: 'Expires 10 Mar 25',
      buttonText: 'VIEW OFFERS',
    },
    {
      id: 7,
      image: 'https://www.shutterstock.com/image-photo/modern-car-rental-agency-office-600nw-2465439621.jpg',
      category: 'CAR RENTALS',
      title: 'Drive Away Deals:',
      description: 'Get 15% OFF on Car Rentals for Your Next Trip',
      expiry: 'Expires 20 Apr 25',
      buttonText: 'RENT NOW',
    },
    {
      id: 8,
      image: 'https://www.shutterstock.com/image-photo/luxury-yacht-sailing-ocean-blue-600nw-2285994453.jpg',
      category: 'CRUISES',
      title: 'Ocean Adventure Offer:',
      description: 'Save 25% on Luxury Cruise Packages',
      expiry: 'Expires 30 May 25',
      buttonText: 'EXPLORE CRUISES',
    },
    {
      id: 9,
      image: 'https://www.shutterstock.com/image-photo/modern-tourism-office-travel-agency-600nw-2465439621.jpg',
      category: 'TOURS',
      title: 'Explore India Deals:',
      description: 'Up to 18% OFF on Guided Tour Packages',
      expiry: 'Expires 15 Jun 25',
      buttonText: 'DISCOVER TOURS',
    },
    {
      id: 10,
      image: 'https://www.shutterstock.com/image-photo/luxury-spa-resort-wellness-center-600nw-2285994453.jpg',
      category: 'SPA & WELLNESS',
      title: 'Relax & Rejuvenate:',
      description: 'Get 20% OFF on Spa Packages Across India',
      expiry: 'Expires 25 Mar 25',
      buttonText: 'BOOK SPA',
    },
    {
      id: 11,
      image: 'https://www.shutterstock.com/image-photo/modern-train-station-platform-high-600nw-2465439621.jpg',
      category: 'TRAIN TICKETS',
      title: 'Rail Journey Discounts:',
      description: 'Save 10% on Premium Train Tickets',
      expiry: 'Expires 12 Apr 25',
      buttonText: 'BOOK TICKETS',
    },
    {
      id: 12,
      image: 'https://www.shutterstock.com/image-photo/luxury-vacation-rental-home-exterior-600nw-2285994453.jpg',
      category: 'VACATION RENTALS',
      title: 'Holiday Homes Special:',
      description: 'Up to 22% OFF on Vacation Rentals',
      expiry: 'Expires 30 Apr 25',
      buttonText: 'VIEW PROPERTIES',
    },
    {
      id: 13,
      image: 'https://www.shutterstock.com/image-photo/adventure-travel-tourism-concept-hiking-600nw-2465439621.jpg',
      category: 'ADVENTURE TRIPS',
      title: 'Thrill Seeker Offer:',
      description: 'Get 15% OFF on Adventure Tours',
      expiry: 'Expires 20 May 25',
      buttonText: 'PLAN TRIP',
    },
    {
      id: 14,
      image: 'https://www.shutterstock.com/image-photo/luxury-event-venue-wedding-banquet-600nw-2285994453.jpg',
      category: 'EVENT PACKAGES',
      title: 'Celebration Deals:',
      description: 'Save 20% on Wedding & Event Packages',
      expiry: 'Expires 15 Jul 25',
      buttonText: 'LEARN MORE',
    },
  ];

const HomeCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [activeTab, setActiveTab] = useState('All Offers'); // New state for active tab
  const trackRef = useRef(null);

  const nextSlide = () => {
    if (currentIndex < offers.length - 2) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const prevSlide = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  // Function to handle tab clicks
  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setCurrentIndex(0); // Reset carousel to first slide when changing tabs
  };

  // Filter offers based on the active tab
  const filteredOffers = activeTab === 'All Offers' 
    ? offers 
    : offers.filter(offer => {
        if (activeTab === 'Flights') return offer.category === 'DOM FLIGHTS';
        if (activeTab === 'Hotels') return offer.category === 'DOM HOTELS' || offer.category === 'INTL HOTELS';
        if (activeTab === 'Bank Offers') return offer.description.toLowerCase().includes('american express'); // Example logic
        if (activeTab === 'Holidays') return offer.category === 'CABS'; // Example logic
        return false;
      });

  return (
    <div className="MCarouselContainer">
      <h2 className="MCarouselTitle">Offers</h2>
      <div className="MCarouselNav">
        <span 
          className={`MCarouselNavItem ${activeTab === 'All Offers' ? 'active' : ''}`} 
          onClick={() => handleTabClick('All Offers')}
        >
          All Offers
        </span>
        <span 
          className={`MCarouselNavItem ${activeTab === 'Bank Offers' ? 'active' : ''}`} 
          onClick={() => handleTabClick('Bank Offers')}
        >
          Bank Offers
        </span>
        <span 
          className={`MCarouselNavItem ${activeTab === 'Flights' ? 'active' : ''}`} 
          onClick={() => handleTabClick('Flights')}
        >
          Flights
        </span>
        <span 
          className={`MCarouselNavItem ${activeTab === 'Hotels' ? 'active' : ''}`} 
          onClick={() => handleTabClick('Hotels')}
        >
          Hotels
        </span>
        <span 
          className={`MCarouselNavItem ${activeTab === 'Holidays' ? 'active' : ''}`} 
          onClick={() => handleTabClick('Holidays')}
        >
          Holidays
        </span>
      </div>

      <div className="MCarousel">
        <button className="MCarouselArrow left" onClick={prevSlide}>‹</button>
        <div className="MCarouselTrack" ref={trackRef} style={{ transform: `translateX(-${currentIndex * (100 / 2)}%)` }}>
          {filteredOffers.map((offer, index) => (
            <div className="MCarouselItem" key={index}>
              <img src={offer.image} alt={`Offer ${index}`} className="MCarouselItemImage" />
              <div className="MCarouselItemContent">
                <span className="MCategory">{offer.category}</span>
                <h3>{offer.title}</h3>
                <p>{offer.description}</p>
                {offer.expiry && <div className="MExpiryTag">{offer.expiry}</div>}
                <button className="MActionButton">{offer.buttonText}</button>
              </div>
            </div>
          ))}
        </div>
        <button className="MCarouselArrow right" onClick={nextSlide}>›</button>
      </div>
    </div>
  );
};

export default HomeCarousel;